import { Button, HStack, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

interface Props {
  cooldownSeconds: number
  onResend: () => void
  isLoading?: boolean
}

export default function ResendTimer({
  cooldownSeconds,
  onResend,
  isLoading,
}: Props) {
  const [secondsRemaining, setSecondsRemaining] = useState(cooldownSeconds)

  useEffect(() => {
    setSecondsRemaining(cooldownSeconds)
  }, [cooldownSeconds])

  useEffect(() => {
    if (secondsRemaining <= 0) return

    const timer = setInterval(() => {
      setSecondsRemaining((prev) => Math.max(0, prev - 1))
    }, 1000)

    return () => clearInterval(timer)
  }, [secondsRemaining])

  const canResend = secondsRemaining === 0 && !isLoading

  return (
    <HStack justify='center' spacing={2}>
      <Text fontSize='sm' color='gray.600'>
        Didn't receive the code?
      </Text>
      {canResend ? (
        <Button
          variant='link'
          colorScheme='purple'
          size='sm'
          onClick={onResend}
          isLoading={isLoading}
        >
          Resend Code
        </Button>
      ) : (
        <Text fontSize='sm' color='gray.500'>
          Resend in {secondsRemaining}s
        </Text>
      )}
    </HStack>
  )
}
